import React from "react";
import { IMAGES } from "../constants";
import { useLanguage } from "../contexts/LanguageContext";

export const Gallery = () => {
  const { t } = useLanguage();
  // Drei kuratierte Bilder. Layout passt sich dynamisch an die Anzahl an,
  // damit Hinzufügen weiterer Fotos später trivial ist.
  const items = IMAGES.gallery;

  // Spalten-Layout für Desktop pro Anzahl der Bilder.
  const desktopLayouts = {
    3: [
      "md:col-span-7 md:row-span-2 aspect-[4/5] md:aspect-auto",
      "md:col-span-5 aspect-[4/3]",
      "md:col-span-5 aspect-[4/3]",
    ],
    4: [
      "md:col-span-6 md:row-span-2 aspect-[4/5] md:aspect-auto",
      "md:col-span-6 aspect-[4/3]",
      "md:col-span-3 aspect-square",
      "md:col-span-3 aspect-square",
    ],
    5: [
      "md:col-span-6 md:row-span-2 aspect-[4/5] md:aspect-auto",
      "md:col-span-6 aspect-[4/3]",
      "md:col-span-4 aspect-square",
      "md:col-span-4 aspect-square",
      "md:col-span-4 aspect-square",
    ],
    6: [
      "md:col-span-6 md:row-span-2 aspect-[4/5] md:aspect-auto",
      "md:col-span-6 aspect-[4/3]",
      "md:col-span-3 aspect-square",
      "md:col-span-3 aspect-square",
      "md:col-span-4 aspect-[4/5]",
      "md:col-span-8 aspect-[16/10]",
    ],
  };
  const layout = desktopLayouts[items.length] || desktopLayouts[6];

  return (
    <section
      id="galerie"
      className="relative py-20 md:py-32 px-5 md:px-8 lg:px-12 bg-[#0A0D14]"
      data-testid="gallery-section"
    >
      <div className="max-w-7xl mx-auto">
        <div className="mb-10 md:mb-14 max-w-3xl">
          <p className="font-script text-[#E63946] text-base md:text-xl mb-3">
            — {t.gallery.eyebrow}
          </p>
          <h2
            className="font-heading font-bold uppercase tracking-tight text-3xl sm:text-5xl md:text-6xl text-white mb-4 md:mb-5 leading-[0.95]"
            data-testid="gallery-title"
          >
            {t.gallery.title}
          </h2>
          <p className="text-white/60 text-sm sm:text-base md:text-lg">
            {t.gallery.subtitle}
          </p>
        </div>

        <div
          className="grid grid-cols-1 md:grid-cols-12 gap-3 md:gap-4"
          data-testid="gallery-grid"
        >
          {items.map((src, i) => (
            <div
              key={src}
              className={`group relative overflow-hidden rounded-lg md:rounded-xl bg-[#121722] ${layout[i]}`}
              data-testid={`gallery-item-${i}`}
            >
              <img
                src={src}
                alt={`YOUR CUT Hamburg — Galerie ${i + 1}`}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A0D14]/60 via-transparent to-transparent opacity-60 group-hover:opacity-30 transition-opacity" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
